<template src="./MyHistorics.html"></template>
<script>
import mixins from "../../../../../../Mixins.js";
export default {
  mixins: [mixins],
  name: "my-historic",
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      showWebTable: true,
      showButtonSmallScrren: false,
      historics: [],
    };
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getHistoric();
    },
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width < 1100) {
        vm.showWebTable = false;
        if (vm.window.width < 420) {
          vm.showButtonSmallScrren = true;
        } else {
          vm.showButtonSmallScrren = false;
        }
      } else {
        vm.showWebTable = true;
      }
    },

    getHistoric() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5,
      });
      this.axios
        .get(
          this.$store.state.filooServer +
            "jobs/historic/" +
            this.$route.params.id,
          {
            headers: { Authorization: this.$session.get("bearer") },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            this.historics = response.data;
            this.$vs.loading.close(this.$refs.content);
          } else if (response.status === 204) {
            this.$vs.loading.close(this.$refs.content);
          }
        });
    },
  },
};
</script>
<style lang="scss" src="./MyHistorics.scss"></style>
